import {
  Component,
  HostBinding,
  Input,
  Output,
  EventEmitter,
  ContentChildren,
  QueryList,
  AfterContentInit
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { UmssTabComponent } from '../tab/tab.component';

export interface TabItem {
  label: string;
  id: string;
  content?: 'Label' | 'Icon' | 'Icon + Label';
  iconName?: string; // Phosphor icon name (e.g., 'phosphorHouse', 'phosphorUser')
  counter?: number;
  disabled?: boolean;
}

@Component({
  selector: 'umss-tabs',
  standalone: true,
  imports: [CommonModule, UmssTabComponent],
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss']
})
export class UmssTabsComponent implements AfterContentInit {
  @HostBinding('style.display') display = 'block';

  constructor() {}

  /** Content props */
  @Input() tabs: TabItem[] = [];
  @Input() activeTabId?: string;

  /** Variant props */
  @Input() size: 'Small' | 'Regular' | 'Large' = 'Regular';
  @Input() variant: 'Default' | 'Pills' | 'Underline' = 'Default';
  @Input() fullWidth: boolean = false;
  @Input() tabsDistribution: 'auto' | 'fill' = 'auto';

  /** Event outputs */
  @Output() tabChange = new EventEmitter<string>();

  /** Content children */
  @ContentChildren(UmssTabComponent)
  tabComponents?: QueryList<UmssTabComponent>;

  ngAfterContentInit(): void {
    // Set up tab click handlers if using content projection
    if (this.tabComponents) {
      this.tabComponents.forEach((tab, index) => {
        tab.tabClick.subscribe(() => {
          if (this.tabs[index]) {
            this.onTabClick(this.tabs[index].id);
          }
        });
      });
    }
  }

  /** Event handlers */
  onTabClick(tabId: string): void {
    const tab = this.tabs.find((t) => t.id === tabId);
    if (tab && !tab.disabled) {
      this.activeTabId = tabId;
      this.tabChange.emit(tabId);
    }
  }

  /** Helper methods */
  isTabActive(tabId: string): boolean {
    return this.activeTabId === tabId;
  }

  trackByTabId(index: number, tab: TabItem): string {
    return tab.id;
  }
}
